import React, { useEffect, useState } from 'react'
import { Button, Modal, Select, TextArea } from '../../../components'
import resultado from '../detalheplano/blocks/resultado'
import recomendacao from '../detalheplano/blocks/recomendacao'
import './agiractmodal.scss'

const Resultado = resultado
const Recomendacao = recomendacao

const Agiractmodal = ({
  open,
  close,
  loading,
  submitting,
  loadingCausas,
  data,
  causasFalha,
  nls,
  onPadronizar,
  onAbrirPivotar,
  onPivotar,
  onAbrirEscalonar,
  onEscalonar,
  onAbrirEncerrar,
  onEncerrar
}) => {
  const [acaoRecomendada, setAcaoRecomendada] = useState(null)
  const [acaoSelecionada, setAcaoSelecionada] = useState(null)
  const [comentario, setComentario] = useState('')
  const [causaSelecionada, setCausaSelecionada] = useState(null)

  const plano = data?.plano || null
  const problemaData = data?.problema || null
  const checkResumo = data?.check_resumo || null
  const recomendacaoData = data?.recomendacao || null

  useEffect(() => {
    if (open) {
      setAcaoRecomendada(recomendacaoData?.acao || null)
      setAcaoSelecionada(null)
      setComentario('')
      setCausaSelecionada(null)
    }
  }, [open, recomendacaoData])

  useEffect(() => {
    if (
      (acaoSelecionada === 'pivotar' || acaoSelecionada === 'escalonar' || acaoSelecionada === 'encerrar') &&
      !causaSelecionada &&
      Array.isArray(causasFalha) &&
      causasFalha.length
    ) {
      setCausaSelecionada(causasFalha[0])
    }
  }, [acaoSelecionada, causasFalha, causaSelecionada])

  const nomePlano = plano
    ? `${nls.planLabel} ${plano.numero_plano} - ${plano.titulo_plano || ''}`
    : ''

  const existeAcaoSelecionada = !!acaoSelecionada

  const handleChangeComentario = value => {
    if (typeof value === 'string') {
      setComentario(value)
      return
    }

    if (value?.target?.value !== undefined) {
      setComentario(value.target.value)
      return
    }

    if (value?.value !== undefined) {
      setComentario(value.value)
      return
    }

    setComentario('')
  }

  const obterCorBotao = acao => {
    if (acaoSelecionada === acao) {
      return 'primary'
    }

    if (!acaoSelecionada && acaoRecomendada === acao) {
      return 'primary'
    }

    return 'default'
  }

  const handleCancelar = () => {
    setAcaoSelecionada(null)
    setComentario('')
    setCausaSelecionada(null)
  }

  const handleSelecionarCausa = e => {
    setCausaSelecionada(e?.value || null)
  }

  const handleClickPivotar = async () => {
    setAcaoSelecionada('pivotar')
    setComentario('')
    setCausaSelecionada(null)
    await onAbrirPivotar()
  }

  const handleClickEscalonar = async () => {
    setAcaoSelecionada('escalonar')
    setComentario('')
    setCausaSelecionada(null)
    await onAbrirEscalonar()
  }

  const handleClickEncerrar = async () => {
    setAcaoSelecionada('encerrar')
    setComentario('')
    setCausaSelecionada(null)
    await onAbrirEncerrar()
  }

  return (
    <Modal
      name='agir-act'
      title={nls.actActionTitle}
      open={open}
      close={close}
      closeText={nls.close}
      size='large'
      actions={(
        <Button color='default' onClick={close}>
          {nls.close}
        </Button>
      )}
    >
      <div className='agiractmodal'>
        {loading && (
          <div className='agiractmodal__loading'>
            {nls.loading}
          </div>
        )}

        {!loading && plano && (
          <div className='agiractmodal__content'>
            <div className='agiractmodal__plan-name'>
              {nomePlano}
            </div>

            <div className='agiractmodal__section'>
              <Resultado
                checkResumo={checkResumo}
                indicadores={problemaData?.indicadores || []}
                nls={nls}
              />
            </div>

            {recomendacaoData && (
              <div className='agiractmodal__section'>
                <Recomendacao
                  recomendacao={recomendacaoData}
                  nls={nls}
                />
              </div>
            )}

            <div className='agiractmodal__section'>
              <div className='agiractmodal__actions-title'>
                {nls.availableActionsTitle}
              </div>

              <div className='agiractmodal__actions'>
                <Button
                  color={obterCorBotao('padronizar')}
                  onClick={() => {
                    setAcaoSelecionada('padronizar')
                    setComentario('')
                    setCausaSelecionada(null)
                  }}
                  disabled={existeAcaoSelecionada && acaoSelecionada !== 'padronizar'}
                >
                  {nls.recommendationActionStandardize}
                </Button>

                <Button
                  color={obterCorBotao('pivotar')}
                  onClick={handleClickPivotar}
                  disabled={existeAcaoSelecionada && acaoSelecionada !== 'pivotar'}
                >
                  {nls.recommendationActionPivot}
                </Button>

                <Button
                  color={obterCorBotao('escalonar')}
                  onClick={handleClickEscalonar}
                  disabled={existeAcaoSelecionada && acaoSelecionada !== 'escalonar'}
                >
                  {nls.recommendationActionEscalate}
                </Button>

                <Button
                  color={obterCorBotao('encerrar')}
                  onClick={handleClickEncerrar}
                  disabled={existeAcaoSelecionada && acaoSelecionada !== 'encerrar'}
                >
                  {nls.recommendationActionClose}
                </Button>
              </div>

              {acaoSelecionada === 'padronizar' && (
                <div className='agiractmodal__action-panel'>
                  <div className='agiractmodal__field'>
                    <label className='agiractmodal__label'>
                      {nls.commentLabel}
                    </label>
                    <TextArea
                      name='comentario'
                      value={comentario}
                      action={handleChangeComentario}
                      disabled={submitting}
                    />
                  </div>

                  <div className='agiractmodal__confirm-actions'>
                    <Button
                      color='primary'
                      onClick={() => onPadronizar(comentario)}
                      disabled={submitting}
                    >
                      {nls.confirm}
                    </Button>

                    <Button
                      color='default'
                      onClick={handleCancelar}
                      disabled={submitting}
                    >
                      {nls.cancel}
                    </Button>
                  </div>
                </div>
              )}

              {acaoSelecionada === 'pivotar' && (
                <div className='agiractmodal__action-panel'>
                  <div className='agiractmodal__field agiractmodal__field--select'>
                    <Select
                      name='causaPivotar'
                      label={nls.reasonLabel}
                      options={causasFalha || []}
                      selected={causaSelecionada || {}}
                      action={handleSelecionarCausa}
                      optionLabel='label'
                      optionValue='value'
                      selectedItem={false}
                      disabled={loadingCausas || submitting}
                    />
                  </div>

                  <div className='agiractmodal__field'>
                    <label className='agiractmodal__label'>
                      {nls.commentLabel}
                    </label>
                    <TextArea
                      name='comentario'
                      value={comentario}
                      action={handleChangeComentario}
                      disabled={submitting}
                    />
                  </div>

                  <div className='agiractmodal__confirm-actions'>
                    <Button
                      color='primary'
                      onClick={() =>
                        onPivotar({
                          causaFalhaId: causaSelecionada?.value,
                          comentario
                        })
                      }
                      disabled={submitting || loadingCausas || !causaSelecionada?.value}
                    >
                      {nls.confirm}
                    </Button>

                    <Button
                      color='default'
                      onClick={handleCancelar}
                      disabled={submitting}
                    >
                      {nls.cancel}
                    </Button>
                  </div>
                </div>
              )}

              {acaoSelecionada === 'escalonar' && (
                <div className='agiractmodal__action-panel'>
                  <div className='agiractmodal__field agiractmodal__field--select'>
                    <Select
                      name='causaEscalonar'
                      label={nls.reasonLabel}
                      options={causasFalha || []}
                      selected={causaSelecionada || {}}
                      action={handleSelecionarCausa}
                      optionLabel='label'
                      optionValue='value'
                      selectedItem={false}
                      disabled={loadingCausas || submitting}
                    />
                  </div>

                  <div className='agiractmodal__field'>
                    <label className='agiractmodal__label'>
                      {nls.commentLabel}
                    </label>
                    <TextArea
                      name='comentario'
                      value={comentario}
                      action={handleChangeComentario}
                      disabled={submitting}
                    />
                  </div>

                  <div className='agiractmodal__confirm-actions'>
                    <Button
                      color='primary'
                      onClick={() =>
                        onEscalonar({
                          causaFalhaId: causaSelecionada?.value,
                          comentario
                        })
                      }
                      disabled={submitting || loadingCausas || !causaSelecionada?.value}
                    >
                      {nls.confirm}
                    </Button>

                    <Button
                      color='default'
                      onClick={handleCancelar}
                      disabled={submitting}
                    >
                      {nls.cancel}
                    </Button>
                  </div>
                </div>
              )}

              {acaoSelecionada === 'encerrar' && (
                <div className='agiractmodal__action-panel'>
                  <div className='agiractmodal__field agiractmodal__field--select'>
                    <Select
                      name='causaEncerrar'
                      label={nls.reasonLabel}
                      options={causasFalha || []}
                      selected={causaSelecionada || {}}
                      action={handleSelecionarCausa}
                      optionLabel='label'
                      optionValue='value'
                      selectedItem={false}
                      disabled={loadingCausas || submitting}
                    />
                  </div>

                  <div className='agiractmodal__field'>
                    <label className='agiractmodal__label'>
                      {nls.commentLabel}
                    </label>
                    <TextArea
                      name='comentario'
                      value={comentario}
                      action={handleChangeComentario}
                      disabled={submitting}
                    />
                  </div>

                  <div className='agiractmodal__confirm-actions'>
                    <Button
                      color='primary'
                      onClick={() =>
                        onEncerrar({
                          causaFalhaId: causaSelecionada?.value,
                          comentario
                        })
                      }
                      disabled={submitting || loadingCausas || !causaSelecionada?.value}
                    >
                      {nls.confirm}
                    </Button>

                    <Button
                      color='default'
                      onClick={handleCancelar}
                      disabled={submitting}
                    >
                      {nls.cancel}
                    </Button>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default Agiractmodal